import imageCompression from "browser-image-compression";

const DEFAULT_OPTIONS = {
  maxSizeMB: 3,
  initialQuality: 0.85,
  useWebWorker: true,
};

export async function compressImageFile(file, options = {}) {
  if (!file || !file.type || !file.type.startsWith("image/")) {
    return file;
  }

  try {
    const compressedFile = await imageCompression(file, {
      ...DEFAULT_OPTIONS,
      ...options,
    });

    if (compressedFile && compressedFile.size < file.size) {
      return compressedFile;
    }

    return file;
  } catch (error) {
    console.error("Image compression failed", error);
    return file;
  }
}

export async function compressImageFiles(files, options = {}) {
  if (!files) return [];

  const fileArray = Array.from(files);

  const compressedFiles = await Promise.all(
    fileArray.map(file => compressImageFile(file, options))
  );

  return compressedFiles;
}
